import React from "react";
import '../css/main.css';

const services = [
  {
    title: "Audio Description",
    desc: "Generate context-aware narration that describes visuals, actions, and on-screen text to enhance accessibility for visually impaired users.",
  },
  {
    title: "ISL Gesture Generation",
    desc: "Convert English or Indian languages into ISL gesture sequences, making video content inclusive for the deaf community.",
  },
  {
    title: "Multilingual Translation",
    desc: "Support for multiple Indian languages to ensure wider accessibility and reach across diverse linguistic audiences.",
  },
  
  
];

const OurServices = () => {
  return (
    <section className="services-section"  id="ourser">
      <h2 className="services-title">
        Our Services
        <span className="services-underline"></span>
      </h2>

      <div className="services-grid">
        {services.map((item, index) => (
          <div className="service-card" key={index}>
            <h4>{item.title}</h4>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OurServices;
